import { Injectable } from '@angular/core'
import { BaseService } from '@appService/base.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MappingRoleService extends BaseService {
  contextPath = this.path + '/map-position-roles'

    searchApi(params: any): Observable<any[]> {
      return this.post(this.contextPath + '/search', params)
    }

    create(body: any): Observable<any[]> {
      return this.post(this.contextPath + '/create', body)
    }

    update(body: any): Observable<any[]> {
      return this.post(this.contextPath + '/update', body)
    }

    delete(body: any): Observable<any[]> {
      return this.post(this.contextPath + '/deleteByIds', body)
    }

    getRoleByPosition(positionId: any) {
      return this.get(this.contextPath + '/get-role-by-position', {positionId})
    }

    getPositionByRole(roleCode: any) {
      return this.get(this.contextPath + '/get-position-by-role', {roleCode})
    }

}
